/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import loadingConfig from "../config/loading.config.json";
import settingsConfig from "../config/settings.config.json";
import errorConfig from "../config/error.config.json";
import bulkImportConfig from "../config/userListsBulkImport.config.json";
import notificationConfig from "../config/notifications.config.json";
import inviteUserConfig from '../config/inviteUser.config.json';
import formData from "../config/createsUserForm.config.json";
import inviteFormData from "../config/inviteUserForm.config.json";
import inviteFormDataDiscount from "../config/inviteUserFormDiscount.config.json";
import createMasqConfig from "../config/createMasquerader.config.json";
import appCardWidgetConfig from "../config/appCardWidget.config.json";
import { VApplication } from "../../../application";
import discountConfig from "../config/discount.config.json";
import { BreadcrumbService } from "../../breadcrumbService";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig, ...(breadcrumbItems || {}) },
      loading: loadingConfig,
      userListImport: bulkImportConfig,
      settings: settingsConfig,
      notifications: notificationConfig,
      error: errorConfig,
      discountConfig: discountConfig,
      inviteUser: inviteUserConfig,
      createMasq: createMasqConfig,
      inviteFormDataDiscount: inviteFormDataDiscount,
      formData: formData,
      inviteFormData: inviteFormData,
      appCard: appCardWidgetConfig,
    };
  }
}
